import type { GuitarChart } from '../guitarChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_AURORA } from '../builtinPulseMaps/palettes.js';
import { assembleImportedGuitarChart } from './importedGuitarChart.js';
import normalImported from './imported/hope-normal.guitar.json' with { type: 'json' };
import hardImported from './imported/hope-hard.guitar.json' with { type: 'json' };
import extremeImported from './imported/hope-extreme.guitar.json' with { type: 'json' };

export const HOPE_GUITAR_VARIANTS: Record<Variant, GuitarChart> = assembleImportedGuitarChart({
  baseSlug: 'hope',
  baseTitle: "Once Again",
  description: "Tristam's Once Again on Rizky Fajar NR's mania set. Three distinct guest diffs — Alice's Easy, Priscilla's Normal, Lunar's Hard — ramp from gentle drops to dense cascades.",
  difficulty: 2,
  palette: PALETTE_AURORA,
  audioSrc: '/audio/guitar/hope.mp3',
  attribution: "\"Once Again\" by Tristam [Monstercat Release] - https://monstercatmedia.bandcamp.com/track/once-again",
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
});
